// extracted by mini-css-extract-plugin
export var table = "_vu-0";